import React, { useEffect, useMemo, useState } from "react";
import { useJwtToken, useLogin, useUserData } from "@me8eon/react_authentication";
import { getToken, useAccessTokenStore } from "@me8eon/access_token";
import { useAttributeValueComponents } from "@me8eon/renderers";
import { useCommonComponents } from "@me8eon/components";
import { durationRemaining } from "@me8eon/authentication";
import { useTime } from "@me8eon/time";
import {} from "@me8eon/storage";
import { nullDebugLog } from "@me8eon/debug";
import { getWorkingStorage } from "@me8eon/react_storage";

export function DevModeAuthentication() {
    const [count, setCount] = useState(0);
    const userData = useUserData();
    const { refreshLogin } = useLogin();
    const jwtTokenFn = useJwtToken();
    const [gotToken, setGotToken] = useState("");
    const { Json } = useAttributeValueComponents();
    const { SelectableButtonBar, TwoColumnAndRest, ClipHeight } = useCommonComponents();
    const [jwt, setJwt] = React.useState<string | undefined>(undefined);
    const store = useAccessTokenStore();
    const tokenNames = ["all", ...Object.keys(store)];
    const selectedOps = useState(tokenNames[0]);
    const [selected] = selectedOps;
    const storage = useMemo(() => getWorkingStorage(), []);
    const time = useTime();
    const [cleanedStore, setCleanedStore] = useState<any>(store);
    useEffect(() => {
        jwtTokenFn().then(setJwt);
    }, []);
    useEffect(() => {
        setGotToken("");
    }, [selected]);
    const rootId = "devmode.authentication";
    useEffect(() => {
        Object.entries(store).map(([k, v]) =>
            v.accessToken?.then(accessToken =>
                setCleanedStore((old: any) => {
                    const duration = Math.floor((old[k].expiry - time().getTime()) / 1000);
                    return ({ ...old, [k]: { ...old[k], accessToken, expiry: old[k].expiry, expiry_date: new Date(old[k].expiry).toISOString(), duration } });
                })));

    }, [store, count]);

    function copyJwtToClipboard() {
        if (jwt) {
            navigator.clipboard.writeText(jwt).then(() => {
                console.log("JWT copied to clipboard");
            }).catch(err => {
                console.error("Failed to copy JWT: ", err);
            });
        }
    }


    return <>
        <h1>User data</h1>
        <TwoColumnAndRest>

            <div><Json rootId={rootId} attribute="devmode.authentication.userdata" value={userData} />
                <div>Duration remaining {Math.floor(durationRemaining(userData, time))}
                    <button onClick={() => setCount(x => x + 1)}>⟳</button>
                </div>
            </div>

            <div data-testid="jwttoken">
                <h2>JWT Token <button style={{ border: 0 }} onClick={copyJwtToClipboard}>📋</button></h2>
                <textarea disabled value={jwt} cols={80} rows={20}></textarea></div>
            <SelectableButtonBar rootId="devmode.search" options={tokenNames} selectedOps={selectedOps} />
            <h2>Access token store</h2>
            <ClipHeight maxHeight="350px" scrollable={true}>
                {selected === "all" && <Json rootId={rootId} attribute="devmode.authentication.tokenStore" value={cleanedStore} />}
                {selected !== "all" && <Json rootId={rootId} attribute="devmode.authentication.token" value={cleanedStore[selected]} />}
            </ClipHeight>
            {selected !== "all" && <>
                <button onClick={() => getToken(store)(selected, refreshLogin, storage, nullDebugLog).then(x => setGotToken(x || "undefined"))}>Get</button>
                <span>{gotToken}</span></>}
        </TwoColumnAndRest>
    </>;
}